import React from "react";
import { Divider as AntDivider } from "antd";

const Divider = () => {
  return (
    <AntDivider
      style={{
        width: "100%",
        borderColor: "rgba(0, 0, 0, 0.15)",
        margin: "8px 0 10px",
      }}
    />
  );
};

export default Divider;
